import { useCurrency } from "@/contexts/CurrencyContext";
import { formatCurrency } from "@/utils/currencyFormatter";

export function usePriceFormatter() {
  const { currency } = useCurrency();

  const formatPrice = (price, currencyCode = currency, decimals = 2) => {
    if (price === undefined || price === null || price === "Veri yok")
      return "Veri yok";

    let numericPrice;
    if (typeof price === "number") {
      numericPrice = price;
    } else {
      numericPrice = parseFloat(price);
    }

    if (Number.isNaN(numericPrice)) return "Veri yok";

    // Currency undefined ise default olarak TRY kullan
    const safeCurrency = currencyCode || "TRY";
    const normalizedCurrency = safeCurrency === "TL" ? "TRY" : safeCurrency;

    try {
      return formatCurrency(numericPrice, normalizedCurrency, {
        showSymbol: true,
        showCode: false,
        decimals,
      });
    } catch (error) {
      console.error("formatCurrency error:", error);
      return `${numericPrice.toLocaleString("tr-TR", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })} TL`;
    }
  };

  return { formatPrice };
}
